// English web texts of Living together (golf 8). Same shape as samenApp.nl.ts. Calm and adult:
// never "debt", "chores", "points" or stars.
export const appSamenEn = {
    words: {
        dinnerTitle: "Who's in for dinner?",
        dinnerTitleCohousing: 'Shared meal',
        costsTitle: 'Split costs',
        costsTitleCohousing: 'Shared costs',
        costsTitleCouple: 'Paying together',
        costsTitleTwoHome: 'Costs for the children',
        emptyStudent: 'Nobody yet. Toasties tonight?',
        emptyShared: 'Nobody has signed up yet.',
        emptyCohousing: 'No sign-ups yet.',
        formerShared: 'Former housemate',
        formerCohousing: 'Former resident',
        formerFamily: 'Former family member',
    },
    nav: {
        dinner: "Who's in",
        dinnerCohousing: 'Shared meal',
        bookings: 'Bookings',
        costs: 'Costs',
    },
    common: {
        save: 'Save',
        cancel: 'Cancel',
        close: 'Close',
        saved: 'Saved',
        you: 'you',
        left: '(moved out)',
        undo: 'Oops',
        moreActions: 'More',
    },
    dinner: {
        intro: "Who's eating tonight, who cooks and how late you can sign up.",
        emptyTitle: 'Eating together?',
        emptyBody: 'Pick a deadline and who cooks.',
        start: 'Start the dinner list',
        started: 'The dinner list is ready.',
        tonight: 'Tonight',
        headCook: 'cook {name}',
        headNoCook: 'no cook yet',
        eaters: 'Eating: {n}',
        guestsExtra: '(+{n} guest)',
        until: 'Sign up until {time} ({left} left)',
        closed: 'Sign-up closed. Ask {name}.',
        closedNoCook: 'Sign-up closed.',
        openForYou: 'The deadline has passed, but you can still change the list.',
        noDinner: 'No house dinner today',
        notDinnerDay: 'There is no house dinner on this day.',
        myChoice: 'My choice',
        imIn: "I'm in",
        imOut: 'Out',
        noChoice: '—',
        guests: 'Guests',
        guestsHint: 'Just the number; no names.',
        groupIn: 'Eating',
        groupOut: 'Not eating',
        groupUnknown: 'Not chosen yet',
        sourceDefault: 'usual',
        sourceHouse: 'house default',
        sourceAway: 'away',
        sourceBoard: 'on the board',
        sourceBy: 'set by {name}',
        sourceCook: 'cooking',
        setFor: 'For {name}',
        cookTitle: 'Cook',
        cookClaim: "I'll cook",
        cookOther: 'Someone else cooks',
        cookRotation: 'Back to the rota',
        cookPick: "Who's cooking?",
        cookFromRotation: 'from the rota',
        noDinnerSet: 'No house dinner today',
        noDinnerUndo: 'House dinner after all',
        note: "Cook's note",
        noteHint: 'Everyone in the house sees this, but not on the board.',
        meal: 'On the menu: {title}',
        groceries: 'Add groceries',
        listChanged: 'Dinner list changed · Split again',
        settings: 'Dinner list settings',
        cutoff: 'Sign up until',
        cutoffHint: 'Between 10:00 and 21:00.',
        days: 'Days with house dinner',
        houseDefault: "Anyone who hasn't chosen",
        houseDefaultUnknown: 'Ask',
        houseDefaultIn: 'Eating',
        houseDefaultOut: 'Not eating',
        remind: 'Reminder before the deadline',
        remindOff: 'Off',
        remindMinutes: '{n} min',
        remindHours: '{n} h',
        cookItem: 'Cooking duty from the rota',
        cookItemNone: 'None (claim it yourself)',
        myDefault: 'My usual',
        myDefaultHint: 'Per weekday. A choice for a specific day always wins.',
        prefIn: 'In',
        prefOut: 'Out',
        prefAsk: 'Ask me',
        signedIn: '{name} is in',
        signedOut: '{name} is out',
        cleared: 'Choice removed',
        closedToast: 'Sign-up is closed.',
        widgetAll: 'To the dinner list',
        widgetNotYet: "You haven't chosen yet.",
        widgetYouIn: "You're in",
        widgetYouOut: "You're out",
    },
    costs: {
        visibleAll: 'Everyone in the house sees expenses and balances. No money goes through AMUMIN.',
        visibleTwoHome: 'Only the parents see this. Children see nothing. No money goes through AMUMIN. Something only appears on the board if you explicitly confirm that yourself for a tablet; you can always take it off again.',
        tabExpenses: 'Expenses',
        tabBalance: 'Balance',
        tabSettled: 'Settled',
        add: 'Expense',
        empty: 'No expenses yet.',
        emptyBody: 'Add an expense; AMUMIN works out who gets what.',
        rowPaid: 'paid by {name}',
        rowFor: 'for {n}',
        new: 'new',
        edited: 'edited',
        questionBadge: 'question open',
        locked: 'closed',
        loadMore: 'Load more',
        deletedList: 'Deleted ({n})',
        deletedHint: 'Can be restored for 30 days.',
        newTitle: 'New expense',
        editTitle: 'Edit expense',
        amount: 'Amount',
        amountHint: 'For example 12.50',
        amountInvalid: 'Enter an amount, for example 12.50.',
        amountTooLarge: 'That amount is too high.',
        ambiguous: 'Did you mean {a} or {b}?',
        confirmLarge: 'Is {amount} right?',
        confirmLargeYes: "Yes, that's right",
        description: 'Description',
        descriptionHint: 'Everyone in the house sees this',
        paidBy: 'Paid by',
        date: 'Date',
        dateFuture: 'A date in the future is not possible.',
        dateLocked: 'That period is closed (up to {date}).',
        split: 'Split',
        splitEqual: 'Equally',
        splitWeights: 'By share',
        splitExact: 'Exact',
        splitDinner: 'Eaters on {date}',
        splitDinnerHint: 'Split among those who ate; guests count for whoever brought them.',
        remaining: '{amount} left to split',
        tooMuch: '{amount} too much',
        perPerson: 'Per person',
        nobody: 'Pick at least one person.',
        enteredBy: 'added by {name}',
        editedBy: 'edited by {name} on {date}',
        edit: 'Edit',
        delete: 'Delete',
        deleteConfirm: 'Are you sure?',
        deleteBody: 'You can restore it for 30 days.',
        deleted: 'Deleted',
        restore: 'Restore',
        restored: 'Restored',
        question: 'Something wrong?',
        questionAsked: 'Your question is on the expense.',
        questionOpen: '{name} asked about this',
        questionResolve: "It's correct",
        questionAdjust: 'Adjust',
        questionWithdraw: 'Withdraw question',
        detailTitle: 'Expense',
        lockedNote: 'This expense is in a closed period.',
        gets: 'gets {amount}',
        owes: 'still has {amount} to settle',
        even: 'is at zero',
        twoHomeOpen: 'still to settle: {amount}',
        suggestions: 'Suggested settlement',
        suggestionLine: '{from} → {to} {amount}',
        copy: 'Copy text',
        copied: 'Copied',
        iPaid: "I've paid",
        wasPaid: 'I got paid',
        settleTitle: 'Settlement',
        settleHint: 'No money goes through AMUMIN; this is only a note.',
        settleSaved: 'Noted. {name} still confirms it.',
        settleSavedConfirmed: 'Noted.',
        pending: 'Waiting settlements',
        pendingLine: '{from} says {amount} was paid',
        confirm: 'Correct',
        reject: 'Not correct',
        waiting: 'waiting for {name}',
        confirmed: 'confirmed',
        unconfirmed: 'not confirmed',
        noLogins: '{names} do not have their own login yet. Until they accept their invitation, you manage their expenses and a settlement to them counts right away (not confirmed).',
        noLoginsOne: '{names} does not have their own login yet. Until they accept the invitation, you manage their expenses and a settlement to them counts right away (not confirmed).',
        inviteHousemates: 'Invite housemates',
        removeSettlement: 'Remove',
        carried: 'Carried-over balance',
        closeTitle: 'Close period',
        closeBody: 'Close up to {date}.',
        closeHelp: 'Open balances carry over. Older entries are locked and deleted 24 months after their date.',
        closeButton: 'Close up to {date}',
        closeQuestions: 'First answer the open questions ({n}).',
        closePending: 'First the waiting settlements ({n}).',
        closeNothing: 'Nothing to close yet.',
        closed: 'Closed up to {date}',
        lastClosed: 'Last closed up to {date}',
        allSettled: 'All settled',
        exportCsv: 'Export CSV',
        settledEmpty: 'No settlements yet.',
        leaverWarn: '{name} still has {amount} open.',
        leaverHint: 'Settle this first, or agree on it together. The balance stays in the overview.',
        offWarn: 'Split costs will be turned off. The data is kept for 12 months and then deleted.',
        widgetGets: 'You get {amount}',
        widgetOwes: 'You still have {amount} to settle',
        widgetEven: 'All settled',
        widgetAll: 'To costs',
        twoHomeConfirm: "Works if you're both parents in this household. Children see nothing.",
        twoHomeConfirmYes: 'Turn on',
    },
    bookings: {
        intro: 'Washing machine, dryer, room or guest bed: see whose turn it is and when.',
        empty: 'Nothing to book yet.',
        emptyBody: 'Pick what you share. You can change the default rules later.',
        addKind: '+ {name}',
        day: 'Day',
        prevDay: 'Previous day',
        nextDay: 'Next day',
        today: 'Today',
        free: 'free',
        mine: 'you',
        closedHours: 'closed',
        dstHour: 'clock change',
        tapFree: 'Tap a free time to book.',
        sheetTitle: 'Book the {resource}',
        start: 'Starts at',
        duration: 'How long',
        forWho: 'For whom',
        book: 'Book',
        booked: '{resource} {time} booked',
        fromDate: 'From',
        toDate: 'Up to and including',
        maxNights: 'At most {n} nights in a row.',
        overlap: '{name} already has {time}. Next free time: {next}.',
        overlapNoNext: 'That time is already booked.',
        takeNext: 'Take {time}',
        err: {
            past: 'That time has already passed.',
            max_days_ahead: 'You can book up to {n} days ahead.',
            slot: 'Pick a time on the {n}-minute grid.',
            dst_hour: 'That time falls in the clock-change hour. Pick another time.',
            max_minutes: 'At most {duration} in a row.',
            closed_hours: 'The {resource} can be used from {from} to {until}.',
            quota: 'You already have {n} bookings for the {resource} this week.',
            max_days: 'At most {n} days in a row.',
        },
        myTitle: 'My bookings',
        myEmpty: "You haven't booked anything.",
        cancel: 'Cancel',
        cancelled: 'Cancelled',
        done: 'Done, free it up',
        freed: 'Free again',
        viaBoard: 'on the board',
        cancelledBoard: 'cancelled on the board, {time}',
        manage: 'Manage',
        manageTitle: 'Things to book',
        addThing: 'Add a thing',
        editThing: 'Edit {name}',
        name: 'Name',
        kind: 'Kind',
        unit: 'Book per',
        unitSlot: 'time slot',
        unitDay: 'whole day',
        slotMinutes: 'Time slot',
        defaultMinutes: 'Default length',
        maxMinutes: 'At most in a row',
        maxDays: 'At most days in a row',
        maxAhead: 'Book ahead (days)',
        perWeek: 'Per person per week',
        perWeekNone: 'No limit',
        openFrom: 'Open from',
        openUntil: 'Open until',
        alwaysOpen: 'Always open',
        onBoard: 'On the hallway board',
        archive: 'Archive',
        unarchive: 'Restore',
        archived: 'Archived',
        minutes: '{n} min',
        hours: '{n} h',
        widgetNext: 'You: {resource} {time}',
        widgetFreeNow: '{resource}: free now',
        widgetBusyUntil: '{resource}: busy until {time}',
        widgetAll: 'To bookings',
        kinds: {
            washer: 'Washing machine',
            dryer: 'Dryer',
            room: 'Room',
            guest_bed: 'Guest bed',
            other: 'Other',
        },
    },
    setup: {
        residents: 'How many of you are there?',
        residentsLess: 'Fewer',
        residentsMore: 'More',
        shares: 'What do you share?',
        shareNames: {
            kitchen: 'Kitchen',
            bathroom: 'Bathroom',
            laundry: 'Washing machine',
            dryer: 'Dryer',
            common_room: 'Common room',
            guest_bed: 'Guest bed',
            groceries: 'Groceries',
            costs: 'Costs',
        },
        sameRights: 'Housemates get the same rights as you.',
        housemates: 'Housemates',
        housematesHint: 'Their names, so they are on the rota and the dinner list right away.',
        housemateName: 'Name of housemate {n}',
        housematesAdd: 'Add housemates',
        housematesAdded: 'Housemates added: {n}',
        housemateEmail: 'Email of housemate {n} (optional)',
        invitesSent: 'Invitations sent: {n}',
        invitesLater: 'Not invited yet. You can do that later under Housemates.',
        oneByOne: 'Or one person on their own (for example a child or a sitter)',
        planTitle: "Here's how we set up the house",
        planBody: 'This is added. Nothing is ever removed; what is already there stays as it is.',
        planRooms: 'Rooms: {list}',
        planDuties: 'Rota: {list}',
        planResources: 'Bookings: {list}',
        planDinner: 'Dinner list: sign up until {time}',
        run: 'Set up the house',
        again: 'Set up again',
        againHint: 'Only adds what is missing. Nothing is removed.',
        doneToast: 'The house is set up.',
        nothingNew: 'Everything was already there.',
        offTitle: 'A module with data is being turned off',
        offDinner: "Who's in will be turned off. The data is kept for 12 months and then deleted.",
        offBookings: 'Bookings will be turned off. The data is kept for 12 months and then deleted.',
        csv: 'Download the costs as CSV',
    },
    push: {
        dinner: "Who's in",
        dinnerHint: '"Are you in?" before the deadline, and the cook hears who is coming.',
        bookings: 'Bookings',
        bookingsHint: 'Your booking starts soon, or someone cancelled on the board.',
    },
    // Ronde 1 golf 8 (ON-3): huisgenoten per e-mail uitnodigen.
    invite: {
        title: 'Invite {name}',
        body: '{name} gets an email with a link and chooses a password. Housemates get the same rights as you.',
        email: 'Email address',
        send: 'Send invitation',
        sent: 'Invitation sent to {email}',
        pending: 'Invited: {email}',
        resend: 'Send again',
        taken: 'This person already has their own login.',
        already: 'This address already belongs to this home.',
        limit: 'Twenty invitations have already been sent today. Please try again tomorrow.',
        inUse: 'This address already has an invitation to follow along. Withdraw that one first.',
        loginNew: 'Log in with your new password. Your email address is already filled in.',
        hint: 'No own login yet: {names}. Tap a name to invite that person by email.',
        landingTitle: 'Invitation to your home',
        landingBody: '{inviter} invites you to {household}. You are in it as {member}.',
        accepted: 'Welcome to {household}. You can now use the app.',
    },
};
//# sourceMappingURL=samenApp.en.js.map